





































































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import MetricPoints from "@/api/metricPoints";
import {InternationalizedField} from "@/api/common";
import InterfaceElement from '@/api/interfaceElement';

@Component({
    components: {
        'modal': Modal,
        'edit-icon': EditIcon,
    },
})
export default class FieldInterfaceElements extends CommonVue {
    @Model('update') public interface_elements_list!: InterfaceElement[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public interface_element: InterfaceElement = null;
    public isNewElement: boolean = false;
    public showModal: boolean = false;

    // noinspection JSMethodCanBeStatic
    public edit(element: InterfaceElement) {
        this.interface_element = element;
        this.isNewElement = false;
        this.showModal = true;
    }

    public newInterfaceElement() {
        this.interface_element = new InterfaceElement();
        this.isNewElement = true;
        this.showModal = true;
    }

    public saveClicked() {
        if (!this.interface_element) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.isNewElement) {
                this.interface_elements_list.push(this.interface_element);
            }
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save interface element', e);
        }
    }

    public checkMandatoryFields() {
        // Check if text is filled
        if(!this.interface_element.screen_id || !this.interface_element.json) {
            throw Error('Please insert the index and json.');
        }
        try {
            this.interface_element.json = JSON.stringify(JSON.parse(this.interface_element.json), null, 2);
        } catch (e) {
            throw Error('Json string is of an invalid format.');
        }
        return;
    }

    public deleteClicked() {
        const newList = this.interface_elements_list.filter((value) => {
            return value !== this.interface_element;
        });

        this.$emit('update', newList);
        this.showModal = false;
    }

}

